import { enumToOptions } from '@libs/types/src/common/enum/util';

export enum CsszInsuranceAdministratorEnum {
    CSSZ = '101',
    BEZPECNOSTNI_SBORY = '102',
    MINISTERSTVO_OBRANY = '103',
    VEZENSKA_SLUZBA = '104',
    GENERALNI_REDITELSTVI_CEL = '105',
    ZAHRANICI = '199',
}

export const csszInsuranceAdministratorEnumOptions = enumToOptions(CsszInsuranceAdministratorEnum, 'enum.csszInsuranceAdministrator.');
